/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";

class PrivateMastermind extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="section-3-et block-3 z-12">
                    <div className="container relative-text">
                        <div className="row mb0">
                            <div className="col s12 center-align">
                                <br className="hide-on-med-and-up"/>
                                <h1 className="f-38 black-text bold-text text-uppercase">This is a private closed door <br/><span className="f-100-long ls-3">Mastermind</span></h1>
                                <p className="f-22 brand-text center-align">Within this select group of entrepreneurs you will find mentors, leaders, and business owners from all over the globe. Join our powerful circle of influence, form new connections, and make a real investment in yourself. </p>
                            </div>
                        </div>
                        <div className="row m0 valign-wrapper hide-on-med-and-down">
                            <div className="col s12 m6 l6 center-align p0">
                                <img className="img-sticky responsive-img" src="https://fownders.s3.us-east-2.amazonaws.com/Mastermind-et-g.png" alt="Gerard Adams & Eric Thomas" />
                            </div>
                            <div className="col s12 m6 l6 center-align p0">
                                <h1 className="f-62 brand-text text-uppercase text-normal right-align mobile-center mb0">Make Your <span className="f-84 ls-3 black-text bold-text m0">Impact</span></h1>
                                <p className="f-26 brand-text right-align mobile-center m0">This is not a boring <br className="hide-on-med-and-down"/> seminar or secret sales event.</p>
                                <p className="f-32 grey-text-3 text-normal text-uppercase right-align mobile-center m0">There is no gimmick.</p>
                                <h1 className="f-32 brand-text text-uppercase right-align mobile-center">Just leaders <br className="hide-on-med-and-down"/> creating leaders.</h1>
                                <div className="col s12 right-align mobile-center p0">
                                    <a href="http://www.fownders.co/mastermind-step-1" className="btn-large cta-org waves-effect waves-light">BUY TICKET</a>
                                    <br/>
                                    <br/><br className="hide-on-small-only"/><br className="hide-on-small-only"/>
                                </div>
                            </div>
                        </div>
                        <div className="row m0 hide-on-large-only">
                            <div className="col s12 center-align p0">
                                <h1 className="f-62 brand-text text-uppercase text-normal mobile-center m0">Make Your <span className="f-impact black-text bold-text">Impact</span></h1>
                                <p className="f-22 brand-text mobile-center m0">This is not a boring seminar or secret sales event.</p>
                                <p className="f-38 grey-text-3 text-normal text-uppercase mobile-center m0">There is no gimmick.</p>
                                <h1 className="f-38 brand-text text-uppercase mobile-center">Just leaders creating leaders.</h1>
                                <div className="col s12 center-align p0">
                                    <a href="http://www.fownders.co/mastermind-step-1" className="btn-large cta-org waves-effect waves-light mb-20">BUY TICKET</a>
                                </div>
                            </div>
                            <div className="col s12 center-align p0">
                                <img className="img-sticky responsive-img" src="https://fownders.s3.us-east-2.amazonaws.com/Mastermind-et-g.png" alt="Gerard Adams & Eric Thomas" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default PrivateMastermind;



// WEBPACK FOOTER //
// ./src/components/private-mastermind.js